export default {
  key: "auth_card",
  action: ["view","create","edit","delete"],
  fields: [
    { key: "id", width: 75 },
    { key: "name" },
    { key: "rfid_cards" },
    { key: "loc", field: "loc.address", value: "loc.loc_id", type: "select" },
    { key: "cp", field: "cp.cp_no", value: "cp.cp_id", type: "select" },
    { key: "active", type: "boolean" },
    { type: "action-btn" },
  ],
  options: {
    loc: {
      key: "cp_locs",
      label: "address",
      value: "loc_id",
      values: [
        { key: "placeholder.all_locs", value: null }
      ]
    },
    cp: {
      key: "cps",
      label: "cp_no",
      value: "cp_id",
      values: [
        { key: "placeholder.all_chargers", value: null }
      ]
    }
  },
  structure: [
    ["name"],
    ["rfid_cards"],
    ["loc","cp"],
    ["active"]
  ],
}